<div class="ramadan-banner">

  <div id='stars'></div>
  <div id='stars2'></div>
  <div id='stars3'></div>
  <div class="accessories">
    <img class="img-responsive" src="assets/img/ramadan20/accessories.png" alt="">
  </div>

  <div class="go_button sm square" routerLink="../home"
       style="position:absolute; top:20px; left:20px; z-index: 3; background:white; color:#333;">
    <i class="icon-left-open"> Back To Games</i>
  </div>

  <div class="content">
    <div class="logo" style="display: flex; flex-flow: column; justify-content: flex-end; align-items: center">
      <img src="assets/img/ramadan20/ramadan-logo.svg" height="100" alt="" style="margin:0 5px">

      <h1 style="font-family: proxima_novalight; font-size:26px; margin:20px 0 0 0;">Ramadan Battle</h1>
      <h1 style="font-family: proxima-nova-bold-webfont; font-size:26px; margin:0;">Fortnite Tournaments</h1>
      <!--<img src="assets/img/games/{{gameName}}/logo.png" height="80" alt="" style="margin:0 5px">-->
    </div>
    <!--<h1>Ramadan Tournaments</h1>-->
    <div class="title">

      <h1 style=" color:#fde0c5;font-size: 36px; text-align: center;  font-family: 'Argor Man Scaqh'">
        Prize pool <br>
        <span style="font-size:36px; font-family: proxima-nova-bold-webfont; ">
                    <!--<img src="assets/img/ramadan20/game-cover/medal_logo.png" width="60" alt="">-->
                    40,500 VB</span>
      </h1>

      <p style="color:#fde0c5; font-size: 14px; font-family: proxima-nova-bold-webfont">#StayHome_PlaySafe</p>


      <!--<p style="color:#fde0c5; font-size: 14px;">The ultimate way to entertain yourself in Ramadan</p>-->
    </div>
    <div class="partners_logo">
      <div class="flex_block" style="justify-content: center; align-items: center; flex-flow: row wrap;">
        <!--<img class="hidden-sm hidden-md hidden-lg" src="assets/img/ramadan20/pubg-logo.png" width="60" alt="">-->
        <!--<img class="hidden-sm hidden-md hidden-lg" src="assets/img/ramadan20/smile-logo.png" width="60" alt="">-->
        <img src="assets/img/ramadan20/aorus-logo.png" width="100" alt="">
        <img src="assets/img/ramadan20/intel-logo.svg" width="60" alt="">
        <img src="assets/img/ramadan20/manlook-logo.svg" width="60" alt="">
        <!--<img src="assets/img/ramadan20/coco-logo.png" width="60" alt="">-->
        <img src="assets/img/ramadan20/gc-logo.png" width="60" alt="">
        <img src="assets/img/ramadan20/ah-logo.png" width="40" alt="">
      </div>
    </div>
  </div>
  <div class="pillar r  hidden-xs hidden-sm">
    <img class="img-responsive" src="assets/img/ramadan20/pillar.png" alt="">
  </div>
  <div class="pillar l hidden-xs">
    <img class="img-responsive" src="assets/img/ramadan20/pillar.png" alt="">
  </div>

  <!--<div class="content-gredient "></div>-->
</div>

<div class="wall">

  <div class="banner-footer"></div>

  <app-ramadan20-tournaments [gameName]="'fortnite'" ></app-ramadan20-tournaments>

</div>